import { render, staticRenderFns } from "./ViewCities.vue?vue&type=template&id=c70bedb6&scoped=true&"
import script from "./ViewCities.vue?vue&type=script&lang=js&"
export * from "./ViewCities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70bedb6",
  null
  
)

export default component.exports